import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dribbble-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M90.2 228.2C99.1 185.8 127.6 150.5 165.9 132.5 169.5 137.4 193.9 171.3 216.6 211.5 152.6 228.5 96.3 228.3 90.2 228.2zM314.6 154C281 124.2 235.3 112.9 192 123.4 195.8 128.5 220.6 162.3 243 203.4 291.6 185.1 312.1 157.5 314.6 154zM140.1 364C180.6 395.6 233.4 400.7 277.4 382 275.4 370 267.4 328.2 248.2 278.4 193.1 297.2 154.4 334.8 140.1 364zM238.9 255.8C235.5 248 231.7 240.3 227.8 232.6 159.6 253 93.4 252.2 87.4 252 87.4 253.4 87.3 254.8 87.3 256.2 87.3 291.3 100.6 323.3 122.4 347.6 144.6 309.7 189.5 269.7 238.9 255.8zM273.8 272.1C291.7 321.2 298.9 361.2 300.3 369.5 331 348.8 352.8 315.9 358.9 277.9 354.3 276.4 316.6 265.2 273.8 272.1zM253.5 223.7C258.3 233.5 261.8 241.5 265.5 250.5 311 244.8 356.2 253.9 360.7 254.9 360.4 222.6 348.9 193 329.8 169.8 326.9 173.7 304 203 253.5 223.7zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM384 256C384 167.8 312.2 96 224 96S64 167.8 64 256 135.8 416 224 416 384 344.2 384 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dribbble-square.js
// module id = C9FG
// module chunks = 144